export const petco = {
  name: 'petco',
  primary: {
    main: '#00205B',
    background: '#FFFFFF',
    contrastText: '#FFFFFF',
    text: '#333333',
    link: '#00205B',
    accent: '#00205B',
    gray: '#D0D0D0',
    textGray: '#959595',
    darkGray: '#595959',
    lightGray: '#F2F2F2',
    transparentYellow: '#FBD58C40',
    yellow: '#FBD58C',
    darkYellow: '#F39A0C',
    lightGreen: '#B9FAD8',
    darkenGreen: '#a5d9be',
    pink: '#F7ACD1',
    purple: '#CDA4F5',
    lightBlue: '#b6f4ff',
    lighterBlue: '#E8FAFE',
  },
  disabled: {
    main: '#D0D0D0',
    dark: '#C0C0C0',
    light: '#F4F6F6',
    text: '#67777E',
    contrastText: '#B0B0B0',
  },
  common: {
    linkDecoration: 'underline',
    borderColor: '#D4DADC',
  },
  header: {
    height: '4rem',
    shadow: 'none',
  },
  nav: {
    color: '#00205B',
    fontSize: 14,
  },
  calendar: {
    top: '2rem',
    selectedColor: '#00205B',
  },
  tabs: {
    active: '#00205B',
    inactive: '#656565',
    borderWidth: 5,
    fontSize: 14,
    spacing: 12,
  },
  input: {
    borderWidth: '0.0625rem',
    height: '2.75rem',
    fontSize: 14,
    checkbox: {
      background: '#00205B',
      check: '#FFFFFF',
    },
  },
  button: {
    text: {
      padding: '2px 0 0',
      borderWidth: 2,
    },
    filter: {
      fontWeight: 400,
    },
  },
  login: {
    background: '#FFFFFF',
    textColor: '#00205B',
    labelColor: '#333333',
  },
  content: {
    placeholder: '#CCCCCC',
    border: '#878787',
  },
  svg: {
    backdropDisplay: 'none',
  },
  status: {
    danger: '#B04040',
    success: '#007500',
    error: {
      main: '#FB4341',
      light: '#FFF0F0',
      lighter: '#FDF3F2',
    },
    warning: {
      main: '#E47A11',
      light: '#FDE8D3',
      lighter: '#FDF7F2',
    },
    info: {
      main: '#00749E',
      light: '#D1F3FF',
      lighter: '#F5FCFF',
    },
  },
  states: {
    pending: '#FBD58C',
    approved: '#72C593',
    declined: '#F0483E',
  },
  fontFamily: 'PetcoCircularTT, Arial, sans-serif',
  heading: {
    micro: '.875rem',
    xSmall: '1rem',
    small: '1.125rem',
    medium: '1.25rem',
    large: '1.375rem',
    xLarge: '1.563rem',
  },
  body: {
    micro: '.6875rem',
    small: '.8125rem',
    medium: '.9375rem',
    large: '1.125rem',
    xLarge: '1.1875rem',
  },
  visuallyHidden: `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  `,
};
